export default {
  sections: {
    asap_orders: {
      title: 'ASAP-bestillinger',
      fields: {
        has_live_orders: {
          label: 'Live-bestillinger',
          tooltip: 'Slå kun denne til, når restauranten rent faktisk går live og begynder at modtage bestillinger',
        },
        has_asap_orders: {
          label: 'Tillader du, at dine kunder afgiver ASAP-bestillinger?',
          tooltip: '*ASAP-bestillinger er baseret på din forberedelsestid',
        },
      },
    },
    scheduled_orders: {
      title: 'Planlagte bestillinger',
      fields: {
        has_scheduled_orders: {
          label: 'Tillader du, at dine kunder bestiller på forhånd til bestemte tidspunkter?',
        },
        has_pre_order: {
          label: 'Tillader du, at dine kunder bestiller mere end én dag i forvejen?',
        },
        max_pre_order_days: {
          label: 'Maksimalt antal dage at bestille i forvejen',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Påmindelser om planlagte bestillinger',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Tidsintervaller i minutter',
          option: '{{value}} minutters interval',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Tilføj maksimalt antal bestillinger pr. tidsinterval',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Maksimalt antal bestillinger pr. tidsinterval',
          placeholder: '5',
        },
        scheduled_order_option_title: {
          label: 'Titel på muligheden Planlæg til senere',
          placeholder: 'Planlæg til senere',
        },
      },
    },
    other: {
      title: 'Andet',
      fields: {
        order_approval_time_step: {
          label: 'Forøgelse / reduktion af bekræftet bestillingstid',
          option: '{{value}} min.',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Tilføj ekstra minutter til bekræftet tid',
          option: '{{value}} min.',
        },
      },
    },
  },
  buttons: {
    save: 'Gem',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Denne restaurant er blevet suspenderet',
      description:
        'For at gå live igen skal du gå til <a>abonnementssiden</a> og genaktivere restauranten. Derefter kan du aktivere live-bestillinger på denne side.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Mindst 1 bestillingsmetode (planlagt eller ASAP) skal være slået til. Du kan ikke deaktivere begge.',
  },
};
